<template>
  <div class="filter-course">
    <p class="text-body mb-2">
      {{ $t('common.labels.select_course') }}
    </p>
    <div
      class="filter-course__wrapper"
      @click="courseClicked"
    >
      <span class="max-w-[230px] lg:max-w-[250px] text-overflow-dots">{{ courseName | UFirstLetter }}</span>
      <span class="filter-course__icon-right">
        <BaseIcon name="expand_more" color="label-text" />
      </span>
    </div>
    <SectionSearchCourse :emit-response="true" @search="searchCourse" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SectionSearchCourse from '@design-system/section/search-course/search-course.vue'
import { ArrayToParams } from '@helper/utils'

export default {
  name: 'FilterInputCourse',
  components: {
    SectionSearchCourse
  },
  data () {
    return {
      courseName: 'English'
    }
  },
  computed: {
    ...mapGetters('local', ['getFilters']),
    ...mapGetters('dialog', ['allDialogs'])
  },
  created () {
    if (this.getFilters && this.getFilters?.course) {
      this.courseName = this.getFilters.course?.name
    }
  },
  methods: {
    ...mapActions('dialog', ['showDialog', 'hideDialog']),
    ...mapActions('local', ['updateListParams', 'updateListQueries']),
    courseClicked () {
      this.showDialog(this.allDialogs.SEARCH_COURSE)
    },
    async searchCourse (course) {
      const p = ArrayToParams(course?.link.parameters)
      await this.updateListParams(p)
      await this.updateListQueries({ page_number: null, teacher_gender: null, ignore_skip: null })

      this.$nuxt.$emit('fetchList')
      this.hideDialog()
    }
  }
}
</script>

<style scoped lang="scss">
.filter-course {
  &__wrapper {
    @apply bg-white border rounded-2xl border-border-text-field lg:h-14 h-12 px-3
    lg:text__text-input-md--regular text__text-input-md--regular text-title flex
    w-full lg:w-[470px] items-center relative cursor-pointer;
  }
  &__icon-right {
    @apply absolute right-3 flex items-center h-full cursor-pointer;
  }
}
</style>
